// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TQ5o","col":"styles_col__1ezy5"};